import axios from 'axios';
import * as Constants from '../common/constants';
import * as HelperFunctions from '../common/functions/helperFunctions';
import AuthService from './authService';
import { UserLaboratoryResultModel } from '../models/user/userLaboratoryResultModel';
import { UserLaboratoryResultFilterModel } from '../models/user/userLaboratoryResultFilterModel';
import { PersonalLaboratoryResultModel } from '../models/user/personalLaboratoryResultModel';

class LaboratoryResultsService {

    authService = new AuthService();

    constructor() {
        //axios.defaults.baseURL = `${Constants.apiUrl}`;
        axios.defaults.headers = {
            "Content-Type": "application/json; charset=utf-8",
            Authorization: `Bearer ${this.authService.getToken()}`,
            Pragma: 'no-cache'
        }
    }

    getAllLaboratoryResults(from: number, numberOfRows: number, filters: UserLaboratoryResultFilterModel) {
        return axios({
            url: `${Constants.apiUrl}/userLabResult/getAll/${from}/${numberOfRows}/`,
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                Authorization: `Bearer ${this.authService.getToken()}`,
                Pragma: 'no-cache'
            },
            data: JSON.stringify(filters)
        })
            .then(res => res.data.data)
            .catch(error =>
                Promise.reject(HelperFunctions.getErrorMessage(error))
            )
    }

    getlaboratoryResult(laboratoryResultId: number) {
        return axios({
            url: `${Constants.apiUrl}/userLabResult/get/${laboratoryResultId}/`,
            method: 'get',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                Authorization: `Bearer ${this.authService.getToken()}`,
                Pragma: 'no-cache'
            }
        })
            .then(res => res.data.data)
            .catch(error =>
                Promise.reject(HelperFunctions.getErrorMessage(error))
            )
    }

    getPersonallaboratoryResults() {
        return axios({
            url: `${Constants.apiUrl}/userLabResult/labTypes/`,
            method: 'get',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                Authorization: `Bearer ${this.authService.getToken()}`,
                Pragma: 'no-cache'
            }
        })
            .then(res => res.data.data)
            .catch(error =>
                Promise.reject(HelperFunctions.getErrorMessage(error))
            )
    }

    addlaboratoryResults(laboratoryResult: UserLaboratoryResultModel) {
        return axios({
            url: `${Constants.apiUrl}/userLabResult`,
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                Authorization: `Bearer ${this.authService.getToken()}`,
                Pragma: 'no-cache'
            },
            data: JSON.stringify(laboratoryResult)
        })
            .then(res => res.data.data)
            .catch(error =>
                Promise.reject(HelperFunctions.getErrorMessage(error))
            )
    }

    updatelaboratoryResults(laboratoryResultId: number, laboratoryResult: UserLaboratoryResultModel) {
        return axios({
            url: `${Constants.apiUrl}/userLabResult/${laboratoryResultId}`,
            method: 'put',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                Authorization: `Bearer ${this.authService.getToken()}`,
                Pragma: 'no-cache'
            },
            data: JSON.stringify(laboratoryResult)
        })
            .then(res => res.data.data)
            .catch(error =>
                Promise.reject(HelperFunctions.getErrorMessage(error))
            )
    }

    deletelaboratoryResult(laboratoryResultId: number) {
        return axios({
            url: `${Constants.apiUrl}/userLabResult/${laboratoryResultId}`,
            method: 'delete',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                Authorization: `Bearer ${this.authService.getToken()}`,
                Pragma: 'no-cache'
            }
        })
            .then(res => res.data.data)
            .catch(error =>
                Promise.reject(HelperFunctions.getErrorMessage(error))
            )
    }

    createPersonallaboratoryResult(personal: PersonalLaboratoryResultModel) {
        return axios({
            url: `${Constants.apiUrl}/userLabResult/createType/`,
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                Authorization: `Bearer ${this.authService.getToken()}`,
                Pragma: 'no-cache'
            },
            data: JSON.stringify(personal)
        })
            .then(res => res.data.data)
            .catch(error =>
                Promise.reject(HelperFunctions.getErrorMessage(error))
            )
    }

    deletePersonallaboratoryResult(laboratoryResultId: number) {
        return axios({
            url: `${Constants.apiUrl}/userLabResult/deleteType/${laboratoryResultId}`,
            method: 'delete',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                Authorization: `Bearer ${this.authService.getToken()}`,
                Pragma: 'no-cache'
            }
        })
            .then(res => res.data.data)
            .catch(error =>
                Promise.reject(HelperFunctions.getErrorMessage(error))
            )
    }
}

export default LaboratoryResultsService;